import { render, staticRenderFns } from "./textInput.vue?vue&type=template&id=20e633e8&scoped=true"
import script from "./textInput.vue?vue&type=script&lang=js"
export * from "./textInput.vue?vue&type=script&lang=js"
import style0 from "./textInput.vue?vue&type=style&index=0&id=20e633e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e633e8",
  null
  
)

export default component.exports